import app from 'flarum/forum/app';

/**
 * The actor's own champis-species.dataSource preference (see
 * addDataSourceSetting.tsx) - true only for a logged-in user who explicitly
 * set it to 'col'. A guest has no preferences() at all, so this is false
 * for them by construction, same as the server-side default (see extend.php's
 * own registerPreference() default).
 *
 * Shared by every place that decides whether to link to a species' COL
 * counterpart (/taxon/{colId}) instead of its GBIF one (/species/{gbifId})
 * when both are known - SpeciesPage.tsx's own redirect, SpeciesLabel.tsx's
 * own link - rather than repeating the same preferences() lookup in each.
 */
export default function wantsCol() {
  return app.session.user?.preferences()?.['champis-species.dataSource'] === 'col';
}
flarum.reg.add('champis-species', 'forum/utils/wantsCol', wantsCol);